(ns ncr.fragment.props.money.property-input
  (:require [clojure.string :as s]
            [react]
            [ncr.fragment.attachment-markup :as am]
            [ncr.fragment.props.money.input :as mi]
            [ncr.fragment.props.money :as money]
            [ncr.etc.pf :as pf]
            [ncr.etc.util :as u]
            [uix.core.alpha :as uix]))

(defn c-netto-brutto [props initial update!]
  (let [label (get props :label "")
        id :netto-brutto
        {:keys [class suggestions]} (.get am/useStore (partial am/get-property-props id))]

    (uix/effect!
      (fn []
        (let [validate #(when-let [v (money/parse %)]
                          (when (money/valid? v) v))]
          (am/register-property id
            {:update! (fn [value event]
                        (let [parsed (when-not (s/blank? value) (money/parse value))]
                          (when (money/valid? parsed)
                            (let [f #(update! (assoc initial % parsed))]
                              (u/on-click-modifiers event
                                {:on-shift-click (fn [_] (f :brutto))
                                 :on-click (fn [_] (f :netto))})))))
             :validate validate
             :get-suggestions #(when (seq %) (money/parse-all %))
             :to-string money/to-string
             :type :money})))
      [id initial update!])

    [pf/c-form-group
     {:label label :class class}
     [mi/c-inline-input-netto-brutto
      {:netto (:netto initial)
       :brutto (:brutto initial)
       :ignore-missing? false
       :display-brutto :both
       :display-netto :absolute
       :display-type :input-group
       :on-change update!
       :hints (map money/parse suggestions)}]]))
